<template>
  <div class="row">
    <div :class="isDashboard ? 'col-12' : 'col-18'" class=" d-flex flex-column align-items-end">
      <div class="">
        <label class="">Subtotal:</label>
        <span class="value">${{ currencyFormat(order?.sub_total?.amount, 0, 2) }}</span>
      </div>
      <div class="d-flex flex-column align-items-end">
        <div v-if="order?.coupon_amount" class="">
          <label v-if="order.shopify_order_number" class="inline-label">Discount{{ order?.coupon_amount?.name ? `(${order.coupon_amount.name})`: '' }}:</label>
          <label v-else class="inline-label">Coupon Discount{{ order?.coupon_amount?.name ? `(${order.coupon_amount.name})`: '' }}:</label>
          <span class="value">${{ currencyFormat(order?.coupon_amount?.value * -1, 0, 2) }}</span>
        </div>
        <div v-if="order?.sales_coupon_amount" class="">
          <label class="inline-label">Coupon Discount{{ order?.sales_coupon_amount?.name ? `(${order.sales_coupon_amount.name})`:'' }}:</label>
          <span class="value">${{ currencyFormat(order?.sales_coupon_amount?.value * -1, 0, 2) }}</span>
        </div>
        <div v-if="order?.point_amount" class="">
          <label class="inline-label">Points Discount:</label>
          <span class="value">${{ currencyFormat(order.point_amount.value * -1, 0, 2) }}</span>
        </div>
        <div v-if="order?.manual_discount_amount > 0" class="">
          <label class="inline-label">Discount:</label>
          <span class="custom-span value">${{ currencyFormat(order.manual_discount_amount) }}</span>
        </div>
      </div>

      <div class="d-flex flex-column align-items-end">
        <div v-if="order?.shipping_method" class="">
          <label class="inline-label">Shipping cost{{ order?.shipping_method ? `(${order.shipping_method})` : ''}}:</label>
          <span class="value">${{ currencyFormat(order?.shipping_cost?.amount, 0, 2) }}</span>
        </div>
        <div v-if="order?.billing_tax" class="">
          <label class="inline-label">Taxes:</label>
          <span class="value">${{ currencyFormat(order?.billing_tax, 0, 2) }}</span>
        </div>
      </div>

      <div class="">
        <label class="inline-label bolder">Grand Total:</label>
        <span class="value bolder">${{ currencyFormat(order?.total.amount, 0, 2) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { currencyFormat } from "@core/helpers/configHelper"

export default {
  name: "BillDetails",
  methods: { currencyFormat },
  props: ["order", "isDashboard"]
}
</script>

<style scoped>
.inline-label {
  display: inline-flex;
}

label {
  text-align: right;
  margin-right: .5rem;
}
span {
  width: 100px;
  display: inline-block;
  text-align: right;
}

.bolder {
  font-weight: bolder;
}
</style>
